import { Network } from "../Network";
import { DistributionEndPoints } from "apis/EndPoints/DistributionEndPoints";

export class DistributionServices {
  static getReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.getReportsEmailSettings.url(
        data?.company,
        data?.project
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: DistributionEndPoints.getReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }

  static updateReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.updateReportsEmailSettings.url(
        data?.company,
        data?.project
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: DistributionEndPoints.updateReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }

  static createReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.createReportsEmailSettings.url(
        data?.company,
        data?.project
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: DistributionEndPoints.createReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }

  static sendOutReportsEmails(data = {}) {
    return Network.fetch(
      DistributionEndPoints.sendOutReportsEmails.url(
        data?.company,
        data?.project
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: DistributionEndPoints.sendOutReportsEmails.method,
        body: JSON.stringify(data),
      }
    );
  }
  static deleteReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.deleteReportsEmailSettings.url(
        data?.company,
        data?.project
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: DistributionEndPoints.deleteReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }

  static getWarehouseReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.getWarehouseReportsEmailSettings.url(data?.company),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: DistributionEndPoints.getWarehouseReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }

  static updateWarehouseReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.updateWarehouseReportsEmailSettings.url(
        data?.company,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method:
          DistributionEndPoints.updateWarehouseReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }

  static createWarehouseReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.createWarehouseReportsEmailSettings.url(
        data?.company,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method:
          DistributionEndPoints.createWarehouseReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }

  static sendOutWarehouseReportsEmails(data = {}) {
    return Network.fetch(
      DistributionEndPoints.sendOutWarehouseReportsEmails.url(data?.company),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: DistributionEndPoints.sendOutWarehouseReportsEmails.method,
        body: JSON.stringify(data),
      }
    );
  }

  static deleteWarehouseReportsEmailSettings(data = {}) {
    return Network.fetch(
      DistributionEndPoints.deleteWarehouseReportsEmailSettings.url(
        data?.company,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method:
          DistributionEndPoints.deleteWarehouseReportsEmailSettings.method,
        body: JSON.stringify(data),
      }
    );
  }
  // static readSharedCustomReport(data = {}) {
  //   return Network.fetch(
  //     DistributionEndPoints.readSharedCustomReport.url(
  //       data?.company,
  //       data?.project
  //     ),
  //     {
  //       headers: {
  //         "Content-type": "application/json",
  //         Authorization: data?.code,
  //         From: data?.loginEmail,
  //       },
  //       method: DistributionEndPoints.readSharedCustomReport.method,
  //     }
  //   );
  // }
}
